
import './style.scss';

import { Box, Drawer, IconButton } from '@mui/material';
import NavigationData from '../../data/Navigation';
import Category from './Category';
import { INavigationCategory, INavigationLink } from '../../interfaces/INavigation';
import { useCallback } from 'react';
import { useAuthContext } from '../../contexts/AuthContext';
import { MenuOpen } from '@mui/icons-material';
import useState from '../../hooks/useState';


interface INavigationProps {
    open: boolean;
    handleClose: () => void;
}

interface IStateValues {
    expandedLinks: INavigationLink[];
}


const Navigation: React.FC<INavigationProps> = ({
    open,
    handleClose
}) => {
    const { user } = useAuthContext();

    const state = useState<IStateValues>({
        expandedLinks: []
    });


    const handleChangeExpandedLinks = useCallback((navigationLink: INavigationLink) => {
        let expandedLinksAux = state.values.expandedLinks;

        if (expandedLinksAux.find(x => x.alias === navigationLink.alias)) {
            expandedLinksAux = expandedLinksAux.filter(x => x.alias !== navigationLink.alias);
        } else {
            expandedLinksAux.push(navigationLink);
        }

        state.update('expandedLinks', expandedLinksAux);
        // eslint-disable-next-line
    }, [state.values.expandedLinks]);


    return (
        <>
            <Drawer
                anchor='left'
                open={open}
                onClose={handleClose}
                PaperProps={{
                    className: 'navigation-admin'
                }}
            >
                <Box className='box-images'>
                    <IconButton size="medium" className='iconbutton-closenavigation' onClick={handleClose}>
                        <MenuOpen fontSize='medium' />
                    </IconButton>
                </Box>

                <Box component='div' className='box-links'>
                    {
                        user && NavigationData.map((category: INavigationCategory) => {
                            return (
                                <Category
                                    title={category.title}
                                    aliasList={category.alias}
                                    items={category.items}

                                    expandedLinks={state.values.expandedLinks}
                                    handleChangeExpandedLinks={handleChangeExpandedLinks}
                                    handleCloseNavigation={handleClose}
                                    key={`navigationcategory-${category.alias}`}
                                />
                            );
                        })
                    }
                </Box>
            </Drawer>
        </>
    );
}


export default Navigation;